import { ClbIcon } from '@celebration/react';
import i18n from '../../../../../lib/i18n';
import IconInfo from '../../../../../common/components/icon-info';
import {
    getAddressFormatted,
    getStringValueOrNoInfoText,
} from '../../../../../utils/string-utils';
import { formatCurrency } from '../../../../../utils/currency-utils';
import LanguageContext from '../../../../../app/contexts/language';
import CopyInfo from '../../../../../common/components/copy-info';
import { IWonOfferDetails } from './IWonOfferDetails';
import './won-offer-details.scss';
import { getUTCDate } from '../../../../../utils/date-utils';

export default function WonOfferDetails({
    setOpen,
    wonOfferLoad,
}: Readonly<IWonOfferDetails>) {
    const { language } = LanguageContext.useLanguage();

    const weightLabel = `${wonOfferLoad.shipment.weight} ${wonOfferLoad.shipment.weightUnitMeasure}`;

    return (
        <div
            className="won-offer-details"
            data-testid="won-offer-details-modal"
        >
            <div className="won-offer-details-modal">
                <div className="won-offer-details-header">
                    <ClbIcon
                        icon="close"
                        size="md"
                        onClick={() => setOpen(false)}
                        data-testid="won-offer-details-close-button"
                    />
                </div>
                <div className="won-offer-details-body">
                    <h2>{i18n.t('Detalhes')}</h2>

                    <hr />
                    <CopyInfo title="Load" info={wonOfferLoad.loadId!} />

                    <CopyInfo
                        title="Pedido"
                        info={wonOfferLoad.shipment.shipmentNumber}
                    />

                    {wonOfferLoad.shipment.freightOrder && (
                        <CopyInfo
                            title="Freight Order"
                            info={wonOfferLoad.shipment.freightOrder}
                        />
                    )}

                    <IconInfo
                        icon="location"
                        title={i18n.t('Origem')}
                        info={getAddressFormatted(wonOfferLoad.route.source)}
                    />

                    <IconInfo
                        icon="map-pin-icon"
                        title={i18n.t('Destino')}
                        info={getAddressFormatted(
                            wonOfferLoad.route.destination,
                        )}
                    />

                    <IconInfo
                        icon="calendar"
                        title={i18n.t('Date')}
                        info={
                            wonOfferLoad.dates.collectionDate &&
                            getUTCDate(
                                wonOfferLoad.dates.collectionDate,
                            )?.toLocaleDateString()
                        }
                    />

                    <IconInfo
                        icon="shopping-cart"
                        title={i18n.t('Carga')}
                        info={wonOfferLoad.shipment.material.name}
                    />

                    <IconInfo
                        icon="truck-icon"
                        title={i18n.t('CaminhaoSugerido')}
                        info={
                            wonOfferLoad.vehicle.description ||
                            wonOfferLoad.vehicle.name
                        }
                    />

                    <IconInfo
                        icon="truck-icon"
                        title={i18n.t('CaminhaoEscolhido')}
                        info={
                            wonOfferLoad.chosenVehicle.description ||
                            wonOfferLoad.chosenVehicle.name
                        }
                    />

                    <div className="won-offer-details-footer">
                        <div className="won-offer-details-footer-attribute">
                            {getStringValueOrNoInfoText(
                                i18n.t(wonOfferLoad.channel!),
                            )}
                        </div>

                        <div className="won-offer-details-footer-attribute">
                            {weightLabel}
                        </div>

                        <div className="won-offer-details-footer-attribute">
                            {formatCurrency(
                                wonOfferLoad.shipment.chargeAmount!,
                                wonOfferLoad.shipment.currency,
                                language,
                            )}
                        </div>

                        {Boolean(wonOfferLoad.shipment.skids) &&
                            wonOfferLoad.shipment.skids > 0 && (
                                <div className="won-offer-details-footer-attribute">
                                    {wonOfferLoad.shipment.skids} Plts
                                </div>
                            )}

                        {wonOfferLoad.isReturnable && (
                            <div className="won-offer-details-footer-attribute">
                                {i18n.t('Returnable')}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
